import React from 'react';
import { SvgIcon } from '../../common/SvgIcon';
import { simpleIconPropsTypes } from '../propTypes';

export const IconRemoved = (props) => {
  const { width = 24, height = 24 } = props;

  return (
    <SvgIcon width={width} height={height} viewBox="0 0 24 24">
      <path
        d="M7 11H17V13H7z"
        transform="translate(-374.000000, -291.000000) translate(270.000000, 113.000000) translate(40.000000, 107.000000) translate(0.000000, 58.000000) translate(64.000000, 13.000000)"
      />
    </SvgIcon>
  );
};

IconRemoved.propTypes = simpleIconPropsTypes;
